$(document).ready(function() {
$(document).on('click', '.add_caart_btnnj, #check_data', function() {
  setTimeout(function() {

var selected_var = $('form[action="/cart/add"][data-type="add-to-cart-form"] input[name="id"]').val();
var matched_option = $('.variants_datta_alll option[value="' + selected_var + '"]');
var new_var_price = matched_option.attr('new_var_price');
var new_var_comp_price = matched_option.attr('new_var_comp_price');
var var_price = matched_option.attr('var_price');
var var_comp = matched_option.attr('var_comp');

        var inputValue = $('#check_data').val();
        if ($('#check_data').is(':checked')) {
          $('span.amount.newwwww.original_price_daata').text(new_var_comp_price);
          $('span.amount.discounted.discounted_data').text(new_var_price);
          $('.product-price-container span.amount.discounted_data').text(new_var_price);
        }else{
          $('span.amount.newwwww.original_price_daata').text(var_comp);
          $('span.amount.discounted.discounted_data').text(var_price);
            $('.product-price-container span.amount.discounted_data').text(var_price);
        }

  

  },500);

      
        var inputValue = $('#check_data').val();
        if ($('#check_data').is(':checked')) {
            $('#check_data').prop('checked', false);
            $('.var_datta_all').remove();
var priec_data_new_nn = $('.product-price-container').attr('price_new');
var compare_datat_new_nn = $('.product-price-container').attr('compared_price_new');
     //  $('.product-price-container span.amount.original_price_daata').text(compare_datat_new_nn);  
     // $('.product-price-container .amount.discounted_data').text(priec_data_new_nn);
          setTimeout(function() { 
 $('.new_daaatta_newww').remove();
          },500);
// var save_price = $('span.badge.onsale').attr('data_save');
//  $('span.badge.onsale').text('Save ' + save_price);
        } else {
$('#check_data').prop('checked', true);
var compare_datat = parseFloat($('.product-price-container').attr('price')) || 0;
var priec_data = parseFloat($('.product-price-container').attr('compared_price')) || 0;
var priec_data_new = parseFloat($('.product-price-container').attr('price_new')) || 0;
var compare_datat_new = parseFloat($('.product-price-container').attr('compared_price_new')) || 0;
var priec_data_meta = parseFloat($('#check_data').attr('price')) || 0;
var compare_price_meta= parseFloat($('#check_data').attr('compared_price')) || 0;
var currency = $('#check_data').attr('currency');
var meta_price_new = $('#check_data').attr('meta_price');             
var meta_price_new_full = parseFloat($('#check_data').attr('full')) || 0;
var total = compare_datat + meta_price_new_full;
var total_final = total.toFixed(2); 
console.log('total_final',total_final);
var add_price_all = (priec_data + priec_data_meta) / 100;
var priec_datavvvv = parseFloat($('.product-price-container').attr('compared_price')) || 0;
var priec_data_metavvvv = parseFloat($('#check_data').attr('compared_price')) || 0;
var add_price_all = (priec_datavvvv + priec_data_metavvvv) / 100;
var new_add_price_all = add_price_all.toFixed(2); 



var meta_price_new_fullaaa = parseFloat($('#check_data').attr('full')) || 0;
var priec_dataaa = parseFloat($('.product-price-container').attr('compared_price_data')) || 0;
var totalaaa = priec_dataaa + meta_price_new_fullaaa;

            var compare_price_all = (compare_datat + compare_price_meta) / 100;
            var formattedPrice = currency + add_price_all.toFixed(2);
            var formattedComparePrice = currency + compare_price_all.toFixed(2);




var comapred_priec_data_meta = parseFloat($('#check_data').attr('main_compared_price')) || 0;
var priec_data = parseFloat($('.product-price-container').attr('compared_price_data')) || 0;
var total_comapred = priec_dataaa + comapred_priec_data_meta;
var formatted_total = currency + total_comapred.toFixed(2);


           // $('.product-price-container span.amount.original_price_daata').text(currency + total_comapred.toFixed(2));  
           //   $('.product-price-container .amount.discounted_data').text(currency + total_final);
 setTimeout(function() {
          
$('.product-price-container span.price ins').before(
    '<div class="new_daaatta_newww">' +
        '<span style="padding-right:10px; text-decoration: line-through; color: #5b5757;" class="amount">' + 
        formatted_total + 
        '</span>' +
    '</div>'
);  
 },500);
          
            var html = '<div class="var_datta_all">' +
                           '<input type="hidden" name="items[1][id]" value="' + inputValue + '">' +
                           '<input type="hidden" name="items[1][quantity]" value="1">' +
                       '</div>';

            $('.selected_varients_wrp').html(html);  
        }
    });



$(document).on('click', 'fieldset.product-form__input label', function(){
// alert('hiii');
var newwewwe = $(this).find('span').text();
$('.new_cart_btn').attr('var_size',newwewwe);  
  
if ($('#check_data').is(':checked')) {

  
setTimeout(function() {
  $('.new_daaatta_newww').remove();
var selected_var = $('form[action="/cart/add"][data-type="add-to-cart-form"] input[name="id"]').val();
var matched_option = $('.variants_datta_alll option[value="' + selected_var + '"]');
var new_var_price = matched_option.attr('new_var_price');
var new_var_comp_price = matched_option.attr('new_var_comp_price');
var var_price = matched_option.attr('var_price');
var var_comp = matched_option.attr('var_comp');
var inputValue = $('#check_data').val();
     
    //  $('.product-price-container .amount.discounted_data').text(currency + total_final);
    // $('.product-price-container span.amount.original_price_daata').text(currency + total_comapred.toFixed(2));
          $('span.amount.newwwww.original_price_daata').text(new_var_comp_price);
          $('span.amount.discounted.discounted_data').text(new_var_price);
          $('.product-price-container span.amount.discounted_data').text(new_var_price);

     // console.log(new_var_price);
     // console.log(new_var_comp_price);
$('.product-price-container span.price ins').before(
    '<div class="new_daaatta_newww">' +
        '<span style="padding-right:20px; text-decoration: line-through; color: #5b5757;" class="amount">' + 
        new_var_comp_price + 
        '</span>' +
    '</div>'
);    
   


},700);
    } else {
   setTimeout(function() {
    // console.log('byyyy'); 
var selected_var = $('form[action="/cart/add"][data-type="add-to-cart-form"] input[name="id"]').val();
var matched_option = $('.variants_datta_alll option[value="' + selected_var + '"]');
var new_var_price = matched_option.attr('new_var_price');
var new_var_comp_price = matched_option.attr('new_var_comp_price');
var var_price = matched_option.attr('var_price');
var var_comp = matched_option.attr('var_comp');
var inputValue = $('#check_data').val();
     
          $('span.amount.newwwww.original_price_daata').text(var_comp);
          $('span.amount.discounted.discounted_data').text(var_price);
         $('.product-price-container span.amount.discounted_data').text(var_price);
  },700);
    }

   setTimeout(function() {
updateCartDataFromVariant();
   },500);

// cartnew_bundle_code////////

});



function updateCartDataFromVariant() {
  var targetVariantId = $('product-form.product-form .product_var_id_new').val();
  var matchedText = $('.varinart_metafield option[variant_id="' + targetVariantId + '"]').text().trim();
  $('.cart_data').val(matchedText);
}
updateCartDataFromVariant();

  
});